<template>
    <span class="bell-icon">
        <svg
            width="63"
            height="63"
            viewBox="0 0 63 63"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
        >
            <rect
                x="17.2346"
                width="48.4226"
                height="48.4226"
                transform="rotate(20 17.2346 0)"
                fill="url(#pattern0)"
            />
            <defs>
                <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlink:href="#image0_101_3" transform="scale(0.0104167)" />
                </pattern>
                <image
                    id="image0_101_3"
                    width="96"
                    height="96"
                    xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAC9klEQVR4nO3dPY9MYRjG8euREBFs4a3YhkKwnYhoKUnEBxA6CZ3ESrazJbGET7FfgW1R0enoUGwpuxsN9q84M80mi5k5z32fM3P9qi32nPs59zXnbea8SGZmZmZmNmtK9gD+F8Ao/19K6cWy7ckewKxzAMkcQDIHkMwBJHMAyRxAsl4EAByNmCZDZwMA5oB7wFtJ62PMYh14A9wFDrc9vqkFnABWgC3aswk8BY5nL19nAXuBxUGzatkAHgB7s5e3U4BTwLuKjd/pPXA6e7k7AbhO3U/9bjaAa9nLn4pmB/kroflDv4A72X1IQXOEs53Y/KFtZi0E4Cq5n/ydfgM3MnoR/qMFcEbSB0kHo2v/w6akC6WUz5FFQ0/EgH2SVtW95kvSIUmrBB+iRp8JL0o6H1xzFBck3Y8sGLYJAuYlfZJ0IKrmmLYknS6ljPP1x8gi14Aldb/5UrN5fBhVLGQNAI5I+iZpf0S9FvyQNF9K+V67UNQacFv9ab7UrKm3IgpFBXAzqE6bQsZcfRM02Pl+jajVsm01m6GqO+OINeCK+td8qenN5YgitV0MqFHLpdoFIgJYCKhRy7naBSICOBlQo5ZTtQtEBHAsoEYt1a+siAigD2e/u6n+pWHEYehI1/V3Te37DDp7XdCscADJHEAyB5DMASRzAMkcQDIHkMwBJHMAyRxAMgeQzAEkcwDJHEAyB5DMASRzAMkcQDIHkMwBJHMAyRxAsqoBAMs15x8BeJw9hrEAyzn3XFfRrxCYruYP9SMEprP5Q90Ogelu/lA3Q2A2mj/UrRCYreYPtRLCxJde0xxqPmphLH30pJSyNMkM2gig19f/T2rS+wd8JpzMASRzAGZmZkk6/xQTYEPNEw3HsVFKmWtzPG3rw1HQl6RpQ/QhgLUJpn3V2ihmFbDAeI85/gmczR7/VABejhHA8+xxTw2at2usjdD81/gtGe0ahPBisGn522bnuZtfEc0+4RnwkebNG5uDv1eA6o8YMzMzMzMzm9QfF1oKnjT4Xi4AAAAASUVORK5CYII="
                />
            </defs>
        </svg>
    </span>
</template>

<script>
export default {
    name: 'IconBell',
};
</script>
